export default __webpack_public_path__ + "static/media/samsung.9e1c60b1.svg";